import { IinitialTenantFeedState } from 'interfaces/tenantFeed.interface';
import * as BrandFeedTypes from './tenantFeed.types';

export default function tenantFeedReducer(state: IinitialTenantFeedState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case BrandFeedTypes.SET_TENANT_FEED: {
      const getBrandFeed: IinitialTenantFeedState = {
        ...state,
        tenant: payload,
      };
      return getBrandFeed;
    }

    case BrandFeedTypes.SET_IS_LOADING_SET_TENANT_FEED: {
      const getIsLoadingSetBrandFeed: IinitialTenantFeedState = {
        ...state,
        isLoadingSetTenantFeed: payload,
      };
      return getIsLoadingSetBrandFeed;
    }

    case BrandFeedTypes.GET_VIDEOS_BY_BRAND: {
      const getVideosByBrand: IinitialTenantFeedState = {
        ...state,
        profileVideosByBrand: payload,
      };
      return getVideosByBrand;
    }

    case BrandFeedTypes.GET_PRODUCTS_BY_BRAND: {
      const getProductsByBrand: IinitialTenantFeedState = {
        ...state,
        profileProductsByBrand: payload,
      };
      return getProductsByBrand;
    }

    default:
      return state;
  }
}
